import React, { Component } from "react";
import { Grid, Nav} from "tabler-react";
import SiteWrapper from "./SiteWrapper.react";
import {Crud_Catalogos} from "./herramientas/Crud_Catalogos";
/**
 * SplitterLayout
 */
import SplitterLayout from 'react-splitter-layout';
import 'react-splitter-layout/lib/index.css';
import { height } from "window-size";
import { Doughnut, Bar, Polar } from 'react-chartjs-2';
//https://www.npmjs.com/package/react-chartjs-2
//http://jerairrest.github.io/react-chartjs-2/
const data = {
	labels: [
		'MXSKYANGEL',
		'MX APM',
		'MX COLOMBIA'
	],
	datasets: [{		
		data: [60, 50, 87],
		backgroundColor: [
		'#FF6384',
		'#36A2EB',
		'#FFCE56'
		],
		hoverBackgroundColor: [
		'#FF6384',
		'#36A2EB',
		'#FFCE56'
		]
	}]
};
class Home extends Component {
	constructor(props) {
		super(props);
		this.state = { };
	  }
	  componentWillMount = () => {
	  }
	  componentDidMount = () => {
		Crud_Catalogos("alarmas/checkip", "get", "", "").then((returnVal) => {
			console.log(returnVal);
		  }).catch(err =>{ console.log(err)});
	  }

	render() {
		return (
			<SiteWrapper>
				<div className="content" style={{ height: "70vh", textAlign: "center" }}>
					<h2>Bienvenido</h2>
				</div>
			</SiteWrapper>
		  );
	}
  
}
export default Home;
